module.exports = __webpack_public_path__ + "img/6.f2e9867a.png";